import { ShoppingCartCheckoutRounded } from "@mui/icons-material";
import React from "react";
import "./CheckoutButton.css";

interface ButtonProps {
  primaryText: string;
  secondaryText: React.ReactNode;
  buttonIcon?: React.ReactNode;
  onClick?: () => void;
}

const CheckoutButton: React.FC<ButtonProps> = ({
  primaryText,
  secondaryText,
  buttonIcon,
  onClick,
}) => {
  return (
    <div>
      <button onClick={onClick} className="tooltip-container">
        <span className="tooltip">{secondaryText}</span>
        <span
          style={{
            textAlign: "center",
            fontFamily: "Ubuntu",
            margin: "auto",
            opacity: 1,
          }}
          className="text"
        >
          {primaryText}
        </span>
        <span
          style={{ textAlign: "center", fontFamily: "Ubuntu", margin: "auto" }}
          className="text1"
        >
         {buttonIcon ? <>{buttonIcon}</> : <ShoppingCartCheckoutRounded />} 
        </span>
      </button>
    </div>
  );
};

export default CheckoutButton;
